import CLIENT from '../utils/restClient';
import Logger, {LOG_LEVELS} from '../utils/logger';
import _ from 'underscore';

export const MODULE_NAME = 'USER_QUESTIONS_CONTROLLER';
const log = new Logger(MODULE_NAME, LOG_LEVELS.DEBUG);

function namespaced(name) {
  return MODULE_NAME+'.'+name;
}
const LOAD = namespaced('LOAD');
const LOAD_OK = namespaced('LOAD_OK');
const LOAD_FAIL = namespaced('LOAD_FAIL');
const UNLOAD = namespaced('UNLOAD');
const SUBMIT_ANSWERS = namespaced('SUBMIT_ANSWERS');
const FIELD_CHANGE = namespaced('FIELD_CHANGE');


export const ACTION_TYPES = {
  LOAD,
  LOAD_OK,
  LOAD_FAIL,
  UNLOAD,
  SUBMIT_ANSWERS,
  FIELD_CHANGE,
};

// In redux parlance, this is a reducer
export const updateSubStateFromAction = (state = {data: undefined, loading: false, error: null}, action) => {
  log.debug('updateSubStateFromAction: ', action, state );
  const getNewState = (action, state) => {
    switch (action.type) {
      case LOAD:
        return  Object.assign({}, state, {loading: true, error: null});
      case LOAD_OK:
        return Object.assign({}, state, {data: action.response, hiddenUserQuestions: action.hiddenUserQuestions, loading: false, error: null});
      case LOAD_FAIL:
        return Object.assign({}, state, {data: undefined, hiddenUserQuestions: undefined, loading: false, error: action.error});
      case UNLOAD:
        return  Object.assign({}, state, {data: undefined, hiddenUserQuestions: undefined, answers: undefined, loading: false, error: null});
      case SUBMIT_ANSWERS:
        return  Object.assign({}, state, {answers: action.answers, loading: false, error: null});
      default:
        return state;
    }
  };
  const newState = getNewState(action, state);
  log.debug('updateSubStateFromAction:  newState', newState );
  return newState;
};

export const API = {
  doLoad: (filterParams) => {
    return (dispatch, getState) => {
      dispatch({type: LOAD});
      log.debug('doLoad(): filterParams: ', filterParams);
      return CLIENT.getUserQuestions(filterParams)
        .then((response) => {
          log.debug('doLoad(): succeeded: ', response);
            let hiddenUserQuestions = {};

            for (let group in response) {
                let visibleUserQuestions = [];
                hiddenUserQuestions[group] = [];
                response[group].map(u => {
                    if(u.GroupName === 'Database Fields' && u.Visible === false)
                    {
                        hiddenUserQuestions[group].push(u);
                    }else{
                        visibleUserQuestions.push(u);
                    }

                });

                response[group] = visibleUserQuestions;
            }
          dispatch({type: LOAD_OK, response: response, hiddenUserQuestions: hiddenUserQuestions});
        })
        .catch((error) => {
          log.debug('doLoad(): failed: ', error);

          dispatch({type: LOAD_FAIL, error});
        });
    }
  },
  doUnload: () => {
    return (dispatch, getState) => {
      log.debug('doUnload(): ');
      dispatch({type: UNLOAD});
    }
  },
  doAnswerUserQuestions: (answers) => {
    return (dispatch, getState) => {
      log.debug('doAnswerUserQuestions(): ', answers);
      dispatch({type: SUBMIT_ANSWERS, answers: answers});
    }
  },
};

export default API;

